import { isFeatureEnabled } from 'owa-feature-flags';

export interface MaxFavoriteSuggestionCounts {
    people: number;
    folder: number;
    search: number;
    category: number;
    group: number;
}

const maxSuggestionCounts: MaxFavoriteSuggestionCounts = {
    people: 4,
    folder: 3,
    search: 0,
    category: 2,
    group: 2,
};

const maxSuggestionCountsWithFavoriteSearch: MaxFavoriteSuggestionCounts = {
    people: 3,
    folder: 2,
    search: 2,
    category: 2,
    group: 2,
};

export default function getMaxFavoriteSuggestionCounts(): MaxFavoriteSuggestionCounts {
    return isFeatureEnabled('tri-favoriteSearch')
        ? maxSuggestionCountsWithFavoriteSearch
        : maxSuggestionCounts;
}
